export type Channel = "voice" | "chat";
